import { of } from "rxjs";
import {
  mergeMap,
  groupBy,
  filter,
  distinctUntilKeyChanged,
  switchMap,
  map,
} from "rxjs/operators";

export const VisibilitySystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),

      mergeMap((group$) =>
        group$.pipe(
          filter((entity) => entity.hasOwnProperty("object3D")),
          filter((entity) => entity.hasOwnProperty("visible")),

          distinctUntilKeyChanged("visible"),

          // insert object3D
          switchMap((definition) => {
            if (definition.object3D) {
              return world.object3DManager
                .getObject3D$(definition.object3D)
                .pipe(map((object3D) => ({ definition, object3D })));
            } else {
              return of({ definition });
            }
          })
        )
      )
    )

    .subscribe(({ definition: { visible, id }, object3D }) => {
      if (object3D && object3D.visible !== visible) {
        object3D.visible = visible;
        object3D.disabled = !visible;
        // force update skinned material
        // if skinned material is hidden at startup
        // update is needed to make this work
        if (visible && object3D.material && object3D.material?.skinning) {
          object3D.material.needsUpdate = true;
        }
        world.change$.next();
      }
    });
};

export default VisibilitySystem;
